import { Link } from 'react-router-dom'

import { IconButton } from '@loadsmart/loadsmart-ui'
import { Layout, Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import user from 'legacy/utils/user'

import { type Proposal } from '../domain/Proposal'
import { AutoSubmitRates } from './AutoSubmitRates'
import { ActionsWrapper, ContentWrapper, ScrollWrapper } from './RfpDetails.styles'
import { RfpStatus } from './RfpStatus'
import { RfpSubmitButton } from './RfpSubmitButton'

export type RfpDetailsHeaderProps = {
  autoSubmit: boolean
  autoSubmitDisabled: boolean
  fixed: boolean
  loading: boolean
  proposal: Proposal
  submitDisabled: boolean
  onChangeProposal: () => void
  onSubmit: () => void
  onToggleAutoSubmit: (autoSubmit: boolean) => void
  onWithdraw: () => void
}

export function RfpDetailsHeader({
  autoSubmit,
  autoSubmitDisabled,
  fixed,
  loading,
  proposal,
  submitDisabled,
  onChangeProposal,
  onSubmit,
  onToggleAutoSubmit,
  onWithdraw,
}: RfpDetailsHeaderProps) {
  const { name, shipperName } = proposal.rfp

  return (
    <ScrollWrapper $fixed={fixed} data-testid="scroll-wrapper">
      <ContentWrapper>
        {user.isLoggedIn() && (
          // @ts-expect-error
          <IconButton as={Link} to={'/all-in-one/rfp'} scale={'small'}>
            <Icon name="arrow-left" />
          </IconButton>
        )}
        <Layout.Stack gap="none">
          <Text variant="heading-md-bold">{`${shipperName} - ${name}`}</Text>
          <Text variant="body-md">
            Fill up the lanes with your desired rate, then submit for shipper
          </Text>
        </Layout.Stack>
        <ActionsWrapper align="center" justify="flex-end">
          <RfpStatus proposal={proposal} />
          <AutoSubmitRates
            autoSubmit={autoSubmit}
            disabled={autoSubmitDisabled}
            onToggleAutoSubmitProposal={onToggleAutoSubmit}
            proposal={proposal}
          />
          <RfpSubmitButton
            disabled={submitDisabled}
            isLoading={loading}
            proposal={proposal}
            onChangeProposal={onChangeProposal}
            onSubmit={onSubmit}
            onWithdraw={onWithdraw}
          />
        </ActionsWrapper>
      </ContentWrapper>
    </ScrollWrapper>
  )
}
